import { en } from './en';

export type TranslationKeys = typeof en;

export type TranslationKey = keyof TranslationKeys;

export const isTranslationKey = (key: string) => key in en;
